import { SortDirType, SortType } from '@/api/financial/types';
import { IconNorthdMS, IconSouthdMS } from '@/constants/icons';
import { Box } from '@mui/material';
import { memo } from 'react';

export const SortIndicator = memo(function SortIndicator({
  sort,
  column,
}: {
  sort: { by: SortType; dir: SortDirType } | null;
  column: SortType;
}): JSX.Element {
  const isActive = sort?.by === column;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          color: isActive && sort?.dir === 'asc' ? 'primary.main' : 'grey.400',
          span: { fontSize: 14, lineHeight: 1, fontWeight: 600 },
          mb: -1,
        }}
      >
        {IconNorthdMS}
      </Box>
      <Box
        sx={{
          color: isActive && sort?.dir === 'desc' ? 'primary.main' : 'grey.400',
          span: { fontSize: 14, lineHeight: 1, fontWeight: 600 },
          mt: -1,
          ml: 2,
        }}
      >
        {IconSouthdMS}
      </Box>
    </Box>
  );
});
